<template>
  <CalicoDashboard 
    class="business-dashboard" 
    :loading="loading" 
    :overflow="!!chatInstance"
    :no-content-padding="!!chatInstance"
  >
    <template #drawer="{ show }">
      <CalicoDrawer 
        :style="[!isOwner && {paddingTop: 0}]" 
        :show="show"
      >
        <h1 
          v-if="isOwner" 
          class="heading--xsmall"
        >
          My Profile
        </h1>
        <CalicoBusinessInfo 
          v-if="business" 
          :show-back="!isOwner"
          :info="{ 
            ...business, 
            photo: business.placesData?.[0]?.business_photo?.photoUri,
            addressLine1: business.street,
            addressLine2: `${business.city}, ${business.state} ${business.zip}`
          }"
          @back="$router.back()"
        />
        <div>
          <!-- BSBLD-1052: Financials tab hidden — re-enable when needed -->
          <!-- <CalicoNavigationTab 
            :to="location.pathname +'#financials-section'"
            :disabled="!financials.userId"      
            @click.prevent="[closeCurrentChat(), scrollToSection('financials-section')]"
          >
            <i class="bi bi-bar-chart-fill" />
            <label class="label--medium">Financials</label>
          </CalicoNavigationTab> -->
          <CalicoNavigationTab 
            :to="location.pathname +'#funding-passport-section'"
            @click.prevent="[closeCurrentChat(), scrollToSection('funding-passport-section')]"            
          >
            <i class="bi bi-currency-dollar" />
            <label class="label--medium">{{ LoanBeaconCopy.TITLE }}</label>
          </CalicoNavigationTab>
          <CalicoNavigationTab 
            :to="location.pathname +'#summary-section'"
            @click.prevent="[closeCurrentChat() ,scrollToSection('summary-section')]"            
          >
            <i class="bi bi-speedometer" />
            <label class="label--medium">
              Summary
            </label>
          </CalicoNavigationTab>
        </div>
        <ConversationsWidget 
          :chats="chats"
          @open="openChat" 
          @create="newChat" 
        />
      </CalicoDrawer>
    </template>
    <template #header>
      <WidgetBetaScore 
        v-if="!chatInstance" 
        :score="betaScore.score"
        :factors="betaScore.factors.slice(0, 3).map(factor => ([factor[1], factor[2]]))"
      />
      <CalicoCloseChat 
        v-else 
        @click="closeCurrentChat" 
      />
    </template>
    <template #attributes>
      <BusinessAttributesWidget
        v-if="!chatInstance && business"
        :data="businessAttributes"
        :is-owner="isOwner"
      />
    </template>
    <template #content>
      <LoanBeaconWidget
        v-if="!chatInstance" 
        id="funding-passport-section"
      />
      
      <WidgetSummary
        v-if="!chatInstance"
        id="summary-section"
        :summary="betaScore.summary"
        :factors="betaScore.factors.slice(0, 5).map(factor => [factor[1], factor[2], factor[3]])" 
      />
      <!-- BSBLD-1052: Financials section hidden — re-enable when needed -->
      <!-- <FinancialsWidget 
        v-if="!chatInstance"
        id="financials-section"
        :data="financials"
        :can-edit="isOwner"
      /> -->
      <div 
        v-if="chatInstance" 
        class="chat"
        @drop.prevent="(e) => dropFiles(e)"
        @dragover.prevent
      >
        <CalicoPromptResult
          v-for="(message, index) in messages"
          :id="`prompt${index}`"
          :key="index"
          :prompt="message.prompt"
          :attachments="message.attachments"
          :reply="message.reply"
          :error="message.error"
        />
      </div>
    </template>
    <template #footer>
      <div class="footer-content">
        <CalicoChatInputField
          ref="chatInputField"
          :files="files"
          :disabled="messages.some(message => message.error)"
          :error="error"
          accept=".pdf,.docx,.xlsx,.csv,.txt,.jpg,.jpeg,.png"
          @send="prompt"
          @upload="setFiles"
          @trash="removeFile"
        />
      </div>
    </template>
  </CalicoDashboard>
</template>

<script>
import CalicoDashboard from "@/components/template/dashboard/index.vue";
import CalicoDrawer from "@/components/calico/drawer/index.vue";
import CalicoBusinessInfo from "@/components/calico/businessInfo/index.vue";
import WidgetBetaScore from "@/components/widget/betascore/index.vue";
import WidgetSummary from "@/components/widget/summary/index.vue";
import CalicoNavigationTab from '@/components/calico/navigationTab/index.vue';
import CalicoCloseChat from '@/components/calico/closeChat/index.vue';
import CalicoChatInputField from '@/components/calico/chatInputField/index.vue';
import CalicoPromptResult from '@/components/pattern/promptResult/index.vue';
import ConversationsWidget from '@/components/widget/conversations/index.vue';
//BSBLD-1052: FinancialsWidget component hidden — re-enable when needed 
// import FinancialsWidget from '@/components/widget/financials/index.vue';
import LoanBeaconWidget from '@/components/widget/loanBeacon/index.vue';
import BusinessAttributesWidget from '@/components/widget/businessAttributes/index.vue';
import services from "@/services";
import { viewPortObserver, formatBusinessAttributes } from "@/utils/helper";
import { LoanBeaconCopy } from '@/enums/index.js'

export default {
  name: "BusinessDashboard",
  components: {
    CalicoDashboard,
    CalicoDrawer,
    CalicoBusinessInfo,
    WidgetBetaScore,
    WidgetSummary,
    CalicoNavigationTab,
    CalicoCloseChat,
    CalicoChatInputField,
    CalicoPromptResult,
    ConversationsWidget,
    //BSBLD-1052: FinancialsWidget component hidden — re-enable when needed 
    // FinancialsWidget,
    LoanBeaconWidget,
    BusinessAttributesWidget,
  },
  data() {
    return {
      location,
      business: null,
      betaScore: {
        score: {
          score: null,
          title: "",
          date: new Date()
        },
        summary: "",
        factors: [],
      },
      chatInstance: null,
      error: "",
      messages: [],
      chats: [],
      files: [],
      isOwner: false,
      loading: false,
      financials: {},
      observer: null,
      loanBeaconActive: false,
      LoanBeaconCopy,

    }
  },
  computed: {
    businessAttributes() {
      return formatBusinessAttributes(this.business)
    },
  },
  watch: {
    messages: {
      handler() {
        this.$nextTick(() => {
          let el = document.querySelector(".chat")
          if(el) {
            el.scrollTo({
              top: el.scrollHeight + 200,
              behavior: 'smooth'
            })
          }
        })
      },
      deep: true,
    }
  },
  async mounted() {
    this.loading = true
    if (!this.$route.params.id)
      this.isOwner = true;
    await this.setBusiness()
    await this.setBetaScore()
    await this.setChats()
    // BSBLD-1052: setFinancials hidden — re-enable when FinancialsWidget is re-enabled
    // await this.setFinancials()
    await this.setLoanBeacon()
    this.loading = false    

    this.portObserver()
  },
  unmounted() {
    if (this.chatInstance) {
      this.closeCurrentChat()
    }
  },
  methods: {
    newChat() {
      this.closeCurrentChat()
      console.log(this.$refs);
      this.$refs.chatInputField.focus();
    },
    setFiles(files) {
      this.error = ''
      if ((files.length + this.files.length) <= 5) {
        this.files = [
          ...this.files,
          ...files
        ]
      } else {
        this.error = 'Max. limit 5 files'
      }
    },
    dropFiles(e) {
      this.error = ''
      const files = [...e.dataTransfer.files]
      const allowedExt = new Set(['pdf', 'docx', 'xlsx', 'csv', 'txt', 'jpg', 'png'])
      const fileExt = (file) => (file.name.split(".").pop() || "").toLowerCase();
      if (files.some(file => !allowedExt.has(fileExt(file)))) {
        this.error = 'Invalid file type'
      } else {
        this.setFiles(files)
      }
    },
    removeFile(idx) {
      console.log(this.files)
      this.files = this.files.filter((_, index) => index != idx)
    },
    portObserver() {
      this.$nextTick(() => {
        // BSBLD-1052: 'financials-section' removed — re-add to array to re-enable
        this.observer = viewPortObserver(this, ['funding-passport-section', 'summary-section']);
      });
    },
    async setBusiness() {
      if (this.isOwner) {
        this.business = await services.user.business.get()
      } else {
        this.business = await services.business.get(this.$route.params.id)
      }
    },
    async setBetaScore() {
      if (this.isOwner) {
        this.betaScore = await services.user.score.get()
      } else {
        this.betaScore = await services.business.score(this.$route.params.id)
      }
    },
    // BSBLD-1052: setFinancials hidden — re-enable when FinancialsWidget is re-enabled
    // async setFinancials() {
    //   this.financials = await services.user.financials.get(this.business.id)
    // },
    async setChats () {
      this.chats = await services.user.chats.get(this.business.id)
      if (this.observer) {        
        this.observer.disconnect();
        this.observer = null;
      }
      this.portObserver();
    },
    async setLoanBeacon() {
      try {
        const { isActive } = await services.business.getLoanBeacon(this.business.id)
        this.loanBeaconActive = isActive
      } catch (error) {
        console.error('[BusinessDashboard] Failed to load Funding Passport™', error)
      }
    },
    async onLoanBeaconToggle(nextValue) {
      const previous = this.loanBeaconActive
      this.loanBeaconActive = nextValue

      try {
        const { isActive, success, forbidden } =
          await services.business.setLoanBeacon(this.business.id)

        if (!success) {
          throw new Error(forbidden ? 'Forbidden' : 'Failed')
        }

        this.loanBeaconActive = isActive
      } catch (error) {
        console.error('[BusinessDashboard] Failed to update Funding Passport™', error)
        this.loanBeaconActive = previous
      }
    },
    async closeCurrentChat() { 
      if (this.chatInstance) {
        this.chatInstance.close()
        this.messages = []
        this.chatInstance = null
        this.setChats()
      }
    },
    async openChat(id) {
      this.closeCurrentChat()
      this.chatInstance = services.chat(this.business.id, id, this.onReply)
      this.messages = await this.chatInstance.getMessages()
    },
    prompt(prompt) {
      const message = {
          prompt,
          attachments: [],
          reply: "",
          error: ""
        }
      if (!this.chatInstance) {
        this.chatInstance = services.chat(this.business.id, null, this.onReply)
      }
      if (this.files.length) {
        message.attachments = this.files.map((file) => ({
          name: file.name,
          type: file.type.split('/').pop() || file.type,
          size: file.size
        }))
      }
      this.messages.push(message)
      this.chatInstance.prompt(prompt, this.files)
      .catch((error) => {
        console.log("error: ", error)
        this.messages[this.messages.length - 1].error = error
      })
      this.files = []
    },
    onReply(reply) {
      if (this.messages.length ) {
        this.messages[this.messages.length - 1].reply += reply
      }
    },
    scrollToSection(id) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    },
  }
};
</script>

<style scoped lang="scss">
.business-dashboard {
  h1 {
    margin: 0;
    color: $color-text-secondary;
  }
  .chat {
    @include stack-space($space-xlarge);
    padding: $space-xlarge $space-medium;
    height: 100%;
    width: 100%;
    overflow: auto;
    scrollbar-width: none;
    box-sizing: border-box;
  }
  .footer-content {
    display: flex;
    padding: 0 $space-large;
  }
}
</style>
